module.exports = __webpack_public_path__ + "static/media/create-account-mobile.771e2c39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/create-account-mobile.jpg
// module id = 440
// module chunks = 0